<span
  *ngIf="visible && type === 'inside-text'"
  class="spinner-border spinner-border-sm"
  role="status"
  aria-hidden="true"
></span>

<div
  *ngIf="visible && type === 'flex-center'"
  class="d-flex justify-content-center"
>
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
